import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **gRPC in HawkClient**

HawkClient provides a powerful and developer-friendly interface to test **gRPC APIs**
including **unary**, **server streaming**, **client streaming**, and **bidirectional streaming** calls.

You can:
- Connect securely using **grpc** or **grpcs**
- Load **.proto** service definitions
- Send streaming messages interactively
- Inspect metadata, trailers, and responses in real time


![gRPC Interface Overview](/send-requests/grpc/overview.png)
`;

const GRPCOverview = () => {
    return (
        <MarkDownRenderer
            title="gRPC Overview"
            markDownText={markdownContent}
        />
    );
};

export default GRPCOverview;
